import React from 'react';

const EmailContent = (props) => {
    
      const {htmlContent} = props;
      
  
    return (
      <iframe
        title="Testing Rule Html"
        srcDoc={htmlContent}
        sandbox="allow-same-origin"
        style={{ border: 'none', width: '100%', height: '1100px' }}
      />
    );
  };
  
  export default EmailContent;

